import * as types from './type';
import { defaultReducerSchema } from '../../../../utils/Helper';

const reducer = defaultReducerSchema(types);

export default reducer;
